require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "mobx-react";
import HomePageStore from "./components/HomePage/HomePageStore";
import { HomePageContent } from "./components/HomePage";
import RepaymentStore from "./stores/RepaymentStore";

const homePageStore = new HomePageStore();

homePageStore.fetchHomePageContentData();
homePageStore.fetchSavedSuburb();

const repaymentStore = new RepaymentStore(homePageStore, true);
const stores = {
  homePageStore,
  repaymentStore,
};

const providerHomePageContent = (
  <Provider {...stores}>
    <HomePageContent />
  </Provider>
);

const homePageContentRoot = document.getElementById("homePage");

if (homePageContentRoot) {
  ReactDOM.render(providerHomePageContent, homePageContentRoot);
}
